/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedIconBubbleEmail_viewer$ref: FragmentReference;
export type PdpSharedIconBubbleEmail_viewer = {|
  +isPdpStfEnabled: ?boolean,
  +$refType: PdpSharedIconBubbleEmail_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleEmail_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isPdpStfEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enablePdpStf",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"enablePdpStf\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '16339c274af40e39af6e9fbee97624f0';
module.exports = node;
